import type {UpholsteryResponseBody} from '@dms/api/new-vehicle';

import type {PricedItemBatchEntry} from '../types/PricedItemBatchEntry';
import {pricedItemGroupKeys} from './pricedItemGroupKeys';
import {removedItem} from './removedItem';

const archivedRow = (upholstery: UpholsteryResponseBody) =>
  removedItem('upholstery', upholstery.id, upholstery.name, upholstery.priceNet);

/**
 * The row of an upholstery archive and its entry for an open group. The entry reads the upholstery
 * when the group is confirmed and sends that version, so a write to it outside the group does not
 * make the batch stale. Its name is free in the batch after it.
 */
export const upholsteryArchiveChange = (
  row: UpholsteryResponseBody,
  readUpholstery: (upholsteryId: string) => Promise<UpholsteryResponseBody>
) => ({
  items: [archivedRow(row)],
  entry: {
    key: pricedItemGroupKeys.upholstery(row.id),
    title: row.name,
    usedValues: pricedItemGroupKeys.usedValue('upholstery', 'name', row.name),
    build: () =>
      readUpholstery(row.id).then((upholstery) => ({
        items: [archivedRow(upholstery)],
        operations: [
          {
            type: 'upholstery.archive' as const,
            targetId: row.id,
            body: {version: upholstery.version},
          },
        ],
      })),
  } satisfies Omit<PricedItemBatchEntry, 'items'>,
});
